export default __webpack_public_path__ + "92e972f64270467ec63b3da1287e6628.svg";